import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const REVIEWS = [{
  name: 'James W.',
  date: '3 days ago',
  rating: 5,
  title: 'Genuinely the best in the UK',
  body: "Ordered three times now. Packaging is discreet, peptides arrive cold, and the COA is always there. Prices beat anyone I've tried."
}, {
  name: 'Sophie R.',
  date: '1 week ago',
  rating: 5,
  title: 'Lab results sold me',
  body: 'I appreciate that the certificate is published before purchase. That transparency is hard to find. Customer service replied within an hour.'
}, {
  name: 'Marcus T.',
  date: '2 weeks ago',
  rating: 5,
  title: 'Fast, clean, professional',
  body: 'Next-day dispatch, traceable batch, sensible pricing. Refreshing to deal with a UK supplier that takes quality this seriously.'
}];
function Stars({
  count,
  size = 'h-3.5 w-3.5'
}: {
  count: number;
  size?: string;
}) {
  return <div className="flex items-center gap-0.5" aria-label={`${count} out of 5 stars`} data-id="element-589">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`${size} ${i < count ? 'fill-primary text-primary' : 'fill-border text-border'}`} strokeWidth={0} data-id="element-590" />)}
    </div>;
}
export function Reviews() {
  return <section className="w-full py-20 lg:py-28 border-t border-border" data-id="element-591">
      <div className="container mx-auto" data-id="element-592">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12" data-id="element-593">
          <div data-id="element-594">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-595">
              Customer reviews
            </p>
            <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground max-w-xl leading-[1.05]" data-id="element-596">
              Rated by researchers, repeatedly
              <span className="text-primary" data-id="element-597">.</span>
            </h2>
          </div>
          <div className="flex items-center gap-4" data-id="element-598">
            <Stars count={5} size="h-5 w-5" data-id="element-599" />
            <div className="flex flex-col" data-id="element-600">
              <span className="font-mono text-lg text-foreground font-medium" data-id="element-601">
                4.8<span className="text-muted-foreground" data-id="element-602"> / 5</span>
              </span>
              <span className="text-[11px] text-muted-foreground" data-id="element-603">
                <span className="font-mono" data-id="element-604">1,247</span> reviews on{' '}
                <span className="font-semibold text-foreground" data-id="element-605">
                  Trustpilot
                </span>
              </span>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-606">
          {REVIEWS.map((r, i) => <motion.article key={r.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="rounded-2xl border border-border bg-card p-6" data-id="element-607">
              <Stars count={r.rating} data-id="element-608" />
              <h3 className="mt-4 text-base font-semibold text-foreground tracking-tight" data-id="element-609">
                {r.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed line-clamp-4" data-id="element-610">
                {r.body}
              </p>
              <div className="mt-5 pt-4 border-t border-border flex items-center justify-between text-[12px]" data-id="element-611">
                <span className="font-medium text-foreground" data-id="element-612">{r.name}</span>
                <span className="font-mono text-muted-foreground" data-id="element-613">
                  {r.date}
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}